var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-tab-view"},[_c('AppSystemInfoCard',{attrs:{"createdAt":_vm.vehicle.createdAt,"updatedAt":_vm.vehicle.updatedAt,"createdBy":_vm.vehicle.createdBy.username,"updatedBy":_vm.vehicle.lastModifiedBy.username}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }